export default {
  profile: state => state.user.profile,
  cart: state => state.cart,
  appInfo: state => state.app.appInfo
}
